module.exports = __webpack_public_path__ + "static/gm-14-33ab159f5f972438324d967deb64573f.jpg";